/** Tarifa diaria de conducción en campo — Yeraldine Marrero */
export const YERALDIN_DAY_RATE = 60;

/** Cobertura técnica TNO Network por día (despliegue, producción, soporte de red) */
export const TNO_COVERAGE_DAY_RATE = 80;

/** Paquete contenido escrito y prensa (suma de partidas editoriales) */
export const PRENSA_PACKAGE_TOTAL = 470;

export const plansData = [
  {
    id: 'bronce',
    tag: 'Plan Bronce',
    title: 'Presencia esencial en el torneo',
    days: 1,
    highlight: false,
    features: [
      '1 día de cobertura en terreno por TNO Network (producción y despliegue técnico).',
      '1 día de conducción y entrevistas en campo con Yeraldine Marrero ($60/día).',
      'Clips editados para redes (hasta 3 piezas cortas).',
      'Publicación en redes oficiales de TNO Network.',
      'Mención del evento de pádel en el portal tnonetwork.com.',
    ],
    idealFor: 'Eventos de un día, fases eliminatorias o prueba de concepto con presencia profesional sin despliegue extendido.',
  },
  {
    id: 'plata',
    tag: 'Plan Plata',
    title: 'Alcance híbrido pre-evento y en vivo',
    days: 2,
    highlight: true,
    features: [
      '2 días de cobertura técnica TNO Network en terreno.',
      '2 días con Yeraldine Marrero en campo ($60/día cada jornada).',
      'Entrevistas previas en sede con organizadores o patrocinadores (1 jornada).',
      'Rotativa publicitaria en la señal de TNO Network.',
      'Difusión en redes TNO Network + amplificación con Yeraldine Marrero.',
      '1 nota de prensa oficial con sello TNO Network.',
    ],
    idealFor: 'Torneos de fin de semana o eventos de dos jornadas que buscan preventa, rotativa y respaldo editorial básico.',
  },
  {
    id: 'oro',
    tag: 'Plan Oro',
    title: 'Cobertura 360° — preventa, evento y post',
    days: 3,
    highlight: false,
    features: [
      '3 días de cobertura integral TNO Network (despliegue técnico completo).',
      '3 días con Yeraldine Marrero: conducción, entrevistas y presencia de marca ($60/día).',
      'Preventa: entrevistas en sede con directivos, coaches y patrocinadores.',
      'Rotativa publicitaria + momentos On-Demand durante las jornadas del torneo.',
      'Paquete completo de contenido escrito y prensa (notas, crónicas, dossier, reportaje post-evento y más).',
      'Menciones de marcas patrocinadoras en señal TNO y redes del ecosistema.',
    ],
    idealFor: 'Eventos de pádel de tres jornadas: máximo ROI para organizadores y patrocinadores, con campaña pre y post evento.',
    includesPrensa: true,
  },
];

export const getPlanTotal = (plan) => {
  const coverage = plan.days * TNO_COVERAGE_DAY_RATE;
  const host = plan.days * YERALDIN_DAY_RATE;
  const prensa = plan.includesPrensa ? PRENSA_PACKAGE_TOTAL : 0;
  return {
    coverage,
    host,
    prensa,
    total: coverage + host + prensa,
  };
};
